import { render, staticRenderFns } from "./ChatDialogWrapper.vue?vue&type=template&id=24f6ab9f&scoped=true&"
import script from "./ChatDialogWrapper.vue?vue&type=script&lang=js&"
export * from "./ChatDialogWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ChatDialogWrapper.vue?vue&type=style&index=0&id=24f6ab9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6ab9f",
  null
  
)

export default component.exports